import { Platform } from "@angular/cdk/platform";
import {
  Component,





  Inject, OnInit
} from "@angular/core";
import {
  AbstractControl,

  FormControl,
  FormGroup,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from "@angular/material/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import { NotifierService } from "angular-notifier";
import moment from "moment";
import { ToastrService } from "ngx-toastr";
import { forkJoin, Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { Message } from "src/app/core/class/message";
import { Common } from "src/app/core/constants/common";
import { ErrorCode } from "src/app/core/constants/error-code";
import { HandsontableFieldTypeContrants } from "src/app/core/constants/handsontable-field-types";
import { CommonService } from "src/app/core/services/common.service";
import { DcFieldConfigService } from "src/app/core/services/dc-field-config.service";
import { TemplateFieldConfigService } from "src/app/core/services/template-field-config.service";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { WarningComponent } from "src/app/shared/components/warning/warning.component";
import { DataType } from "src/app/shared/models/data-type.model";
import { FieldConfig } from "src/app/shared/models/field-config.model";
import { FieldType } from "src/app/shared/models/field-type.model";
import { FieldValidation } from "src/app/shared/models/field-validation.model";
import { FixedFunction } from "src/app/shared/models/fixed-function.model";
import { TemplateFieldConfig } from "src/app/shared/models/template-field-config.model";
import { DateFormat } from "../../../../../../../core/class/date-format";

export interface DataDialog {
  listFields: Array<FieldConfig>;
  listSignatureConfigCustomer: Array<any>;
  fieldConfig: FieldConfig;
  templateId: number;
  orderNoNew: number;
}

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MM YYYY",
  },
};

@Component({
  selector: "app-dialog-field-config",
  templateUrl: "./dialog-field-config.component.html",
  styleUrls: ["./dialog-field-config.component.scss"],
  providers: [
    // DateFormat,
    { provide: MAT_DATE_LOCALE, useValue: "vi" },
    {
      provide: DateAdapter,
      useClass: DateFormat,
      deps: [MAT_DATE_LOCALE, Platform],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class DialogFieldConfigComponent
  extends BaseComponent
  implements OnInit {
  public mode: "edit" | "create" = "create";

  // dataType defines
  public readonly DATA_TYPE_INPUT = "input";
  public readonly DATA_TYPE_FORMULA = "formula";
  public readonly DATA_TYPE_FIXED = "fixed";
  public readonly DATA_TYPE_REF = "ref";
  public readonly DATA_TYPE_REF_CUSTOMER = "tham_chieu_ben_khach_hang";
  public readonly DATA_TYPE_REF_ENTERPRISE = "tham_chieu_ben_lap";
  public readonly DATA_TYPE_SELECT = "select";
  public readonly DATA_TYPE_CURRENCY = "currency";
  public readonly DATA_TYPE_CUSTOMER = "customer";
  public readonly DATA_TYPE_CONTRACT_CODE = "contract_code";
  // fieldType defines
  public readonly FIELD_TYPE_COMBOBOX = "combobox";
  public readonly FIELD_TYPE_TEXTBOX = "textbox";
  public readonly FIELD_TYPE_CHECKBOX = "checkbox";
  public readonly FIELD_TYPE_RADIO = "radiobox";
  public readonly datePattern = Common.DATE_PATTERN;

  public readonly listFieldTypeDefine = [
    this.FIELD_TYPE_COMBOBOX,
    this.FIELD_TYPE_CHECKBOX,
    this.FIELD_TYPE_RADIO,
  ];

  public readonly moneyFormat = "number_money_format";
  public readonly number = "number";

  public readonly NUMBER_TO_MONEY_TEXT = "NUMBER_TO_MONEY_TEXT";

  public mainFormGroup: FormGroup;

  public listGroup: FieldConfig[] = [];
  public listDataTypes: DataType[] = [];
  public listCategories: any[] = [];
  public listFieldTypes: FieldType[] = [];
  public listTypes: FieldType[] = [];
  public listField: FieldConfig[] = [];
  public listFields: FieldConfig[] = [];
  public listFieldCustomer: FieldConfig[] = [];
  public relatedField: FieldConfig[] = [];
  private listFieldWithPosition: any[] = [];
  public listRows: Observable<any[]>;
  public listCategoryFields: any[] = [];
  public listFixedFunctions: FixedFunction[] = [];
  public listCategoriesCache: any[] = [];
  public listDataCategories: any[] = [];
  public listSignatureConfigCustomer: any[] = [];
  public listMoneyFields: FieldConfig[] = [];

  public fieldFormulaName: FormControl = new FormControl(null);
  public searchCategoryFieldCtrl: FormControl = new FormControl("");
  public listCategoryField: Observable<any>;

  public fixedFields: FieldConfig[] = [];

  public customerCategoryId: number = null;
  public customerCodeCategoryId: number = null;
  public listMoneyData: any[] = [];

  maxDate = new Date();

  constructor(
    private dialog: MatDialogRef<DialogFieldConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: DataDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private dcFieldConfigService: DcFieldConfigService,
    private templateFieldConfigService: TemplateFieldConfigService,
    public matDialog: MatDialog,
    public toastr: ToastrService
  ) {
    super(commonService, message);
    this.notifier = notifier;
    this.initForm();
  }

  ngOnInit() {
    if (this.dataDialog.listSignatureConfigCustomer) {
      this.listSignatureConfigCustomer = this.dataDialog.listSignatureConfigCustomer;
    }
    this.initData();
    if (this.dataDialog.listFields) {
      let listFieldTemp: FieldConfig[] = [];
      this.dataDialog.listFields.forEach((data) => {
        if (data.type) {
          if (
            data.type.code == "combobox" &&
            ((this.dataDialog.fieldConfig &&
              data.code !== this.dataDialog.fieldConfig.code) ||
              !this.dataDialog.fieldConfig)
          ) {
            listFieldTemp.push(data);
          }
        }
        if (data.children) {
          data.children.forEach((child) => {
            if (child.type) {
              if (
                child.type.code == "combobox" &&
                ((this.dataDialog.fieldConfig &&
                  data.code !== this.dataDialog.fieldConfig.code) ||
                  !this.dataDialog.fieldConfig)
              ) {
                listFieldTemp.push(child);
              }
            }
          });
        }
      });
      this.listField = listFieldTemp;

      this.listFieldWithPosition = this.processFieldWithPosition(
        this.dataDialog.listFields
      );
      if (this.dataDialog.fieldConfig) {
        this.listFields = this.listFields.filter((item) => {
          return (
            item.fieldConfigId !== this.dataDialog.fieldConfig.fieldConfigId
          );
        });
      }

      this.listGroup = this.dataDialog.listFields.filter((field) => {
        return (
          field.group &&
          (!this.dataDialog.fieldConfig ||
            field.fieldConfigId !== this.dataDialog.fieldConfig.fieldConfigId)
        );
      });
      this.listMoneyFields = [];
      this.dataDialog.listFields.forEach((field) => {
        if (
          field.dataType &&
          field.dataType.code === this.DATA_TYPE_CURRENCY &&
          ((this.dataDialog.fieldConfig &&
            this.dataDialog.fieldConfig.fieldConfigId !==
            field.fieldConfigId) ||
            !this.dataDialog.fieldConfig)
        ) {
          this.listMoneyFields.push(field);
        }
        if (field.children) {
          field.children.forEach((child) => {
            if (
              child.dataType &&
              child.dataType.code === this.DATA_TYPE_CURRENCY &&
              ((this.dataDialog.fieldConfig &&
                this.dataDialog.fieldConfig.fieldConfigId !==
                child.fieldConfigId) ||
                !this.dataDialog.fieldConfig)
            ) {
              this.listMoneyFields.push(child);
            }
          });
        }
      });
    }
    this.initFieldSearch();
    if (this.dataDialog.fieldConfig) {
      this.mode = "edit";
      console.log(this.dataDialog.fieldConfig);
      
      this.mapModelToForm(this.dataDialog.fieldConfig);
    }
    this.searchCategoryField();
  }

  initForm(): void {
    this.mainFormGroup = new FormGroup({
      isGroup: new FormControl(null),
      isMultipleGroup: new FormControl(null),
      name: new FormControl(null, [Validators.required]),
      nameGroup: new FormControl(null, this.nameGroupValidation()),
      mergeFieldStart: new FormControl(null),
      mergeFieldEnd: new FormControl(null),
      note: new FormControl(null, Validators.maxLength(4000)),
      mergeField: new FormControl(null),
      group: new FormControl(null),
      type: new FormControl(
        this.FIELD_TYPE_TEXTBOX,
        this.fieldTypeValidation()
      ),
      dataType: new FormControl(
        this.DATA_TYPE_INPUT,
        this.dataTypeValidation()
      ),
      defaultValue: new FormControl(null, this.defaultValueValidation()),
      isHidden: new FormControl(null),
      isRequired: new FormControl(null),
      minLength: new FormControl(null, [
        this.minLengthValidation(),
        // this.compareMinLengthMaxLength(),
      ]),
      maxLength: new FormControl(null, [
        this.maxLengthValidation(),
        // this.compareMaxLengthMinLength(),
      ]),
      category: new FormControl(null, this.categoryValidation()),
      fixedFieldCode: new FormControl(null, this.fixedValidation()),
      editorSignatureId: new FormControl(null),
      formula: new FormControl(null),
      relatedFieldDataCode: new FormControl(null),
      refCategoryField: new FormControl(
        null,
        this.refCategoryFieldValidation()
      ),
      refCategory: new FormControl(null, this.refCategoryValidation()),
      fixedFunction: new FormControl(null, this.fixedValidation()),
      relatedFieldCode: new FormControl(
        null,
        this.relatedFieldCodeValidation()
      ),
      fixedMoneyFieldCode: new FormControl(
        null,
        this.fixedMoneyFieldValidation()
      ),
    });
    this.mainFormGroup.controls.editorSignatureId.valueChanges.subscribe((value) => {
      const mergeField = this.mainFormGroup.controls.mergeField;
      mergeField.setValidators(value ? [Validators.required] : []);
      mergeField.updateValueAndValidity();
    });
    this.mainFormGroup.controls.nameGroup.valueChanges.subscribe((value) => {
      this.mainFormGroup.controls.mergeFieldStart.patchValue(
        value ? "START_" + value : ""
      );
      this.mainFormGroup.controls.mergeFieldEnd.patchValue(
        value ? "END_" + value : ""
      );
      if (!value) {
        this.mainFormGroup.controls.isMultipleGroup.patchValue(false);
      }
    });
  }

  initFieldSearch(): void {
    this.listRows = this.fieldFormulaName.valueChanges.pipe(
      startWith(""),
      map((value) => {
        if (!value || !value.trim()) {
          return this.listFieldWithPosition;
        }
        return this.listFieldWithPosition.filter((field) => {
          const optionLabel = `${field.position} - ${field.name}`;
          return optionLabel.toLowerCase().includes(value.trim().toLowerCase());
        });
      })
    );
  }

  isError(formControl: string, validation: string): boolean {
    return (
      this.mainFormGroup.controls[formControl].errors &&
      this.mainFormGroup.controls[formControl].errors[validation]
    );
  }

  submitForm(): void {
    if (this.mainFormGroup.invalid) {
      this.mainFormGroup.markAllAsTouched();
      return;
    }
    const fieldConfig = this.mapDataFormToModel();
    if(fieldConfig.fixedFunction && fieldConfig.fixedFunction.code === 'SUM'){
      fieldConfig.type = this.fixedFields[0].type
    }
    let listMergeField: string[] = [];
    if (this.dataDialog.listFields) {
      this.dataDialog.listFields.forEach((item) => {
        if (item.mergeField) {
          listMergeField.push(item.mergeField);
        }
        if (item.children) {
          item.children.forEach((child) => {
            if (child.mergeField) {
              listMergeField.push(child.mergeField);
            }
          });
        }
      });
    }

    if (this.mode == "create") {
      if (listMergeField.length) {
        const temp = listMergeField.findIndex(
          (item) => item == fieldConfig.mergeField
        );
        if (temp != -1) {
          this.mainFormGroup
            .get("mergeField")
            .setErrors({ mergeFieldExist: true });
          return;
        }
      }
    }

    if (this.mode == "edit") {
      if (listMergeField.length) {
        const temp = listMergeField.findIndex(
          (item) => item == fieldConfig.mergeField
        );
        if (
          temp !== -1 &&
          fieldConfig.mergeField !== this.dataDialog.fieldConfig.mergeField
        ) {
          this.mainFormGroup
            .get("mergeField")
            .setErrors({ mergeFieldExist: true });
          return;
        }
      }
    }
    if (
      (!this.dataDialog.fieldConfig || this.dataDialog.fieldConfig.parentId) &&
      !fieldConfig.parentId
    ) {
      // xu ly chuyen truong ra khoi nhom
      // fieldConfig.fieldConfigId = null;
      fieldConfig.orderNo = this.dataDialog.orderNoNew;
      const templateFieldConfig: TemplateFieldConfig =
        TemplateFieldConfig.build();
      templateFieldConfig.fieldConfig = fieldConfig;
      templateFieldConfig.templateId = this.dataDialog.templateId;
      if (this.dataDialog.fieldConfig && this.dataDialog.fieldConfig.parentId) {
        const parent = this.dataDialog.listFields.find(item => item.fieldConfigId === this.dataDialog.fieldConfig.parentId);
        const listChild = parent.children.filter(child => {
          return child.fieldConfigId !== this.dataDialog.fieldConfig.fieldConfigId
        });
        const listFieldChangeOrder = listChild.map((child, index) => {
          child.orderNo = index + 1;
          return child
        })
        // this.dcFieldConfigService
        //   .deleteFieldConfig(
        //     [this.dataDialog.fieldConfig.fieldConfigId],
        //     this.dataDialog.templateId
        //   )
        //   .subscribe((res) => {
        //     if (!res || !res.success) {
        //       if (res) {
        //         this.handleError(
        //           res.code ? res.code : null,
        //           res.message ? res.message : null
        //         );
        //       }
        //       return;
        //     }
        this.templateFieldConfigService
          .saveAllTemplateFieldConfig(
            [templateFieldConfig],
            this.dataDialog.templateId
          )
          .subscribe((response) => {
            if (response && response.code === ErrorCode.NotPermissionTemplate) {
              this.toastr.error(this.message.getMessage('messages.check_permission'));
              return;
            }
            if (!response || !response.data || !response.data.length) {
              if (response) {
                this.handleError(
                  response.code ? response.code : null,
                  response.message ? response.message : null
                );
              }
              return;
            }
            if (listFieldChangeOrder.length) {
              this.dcFieldConfigService.saveFieldConfig(listFieldChangeOrder, this.dataDialog.templateId).subscribe(res => {
                if (res && res.code === ErrorCode.NotPermissionTemplate) {
                  this.toastr.error(this.message.getMessage('messages.check_permission'));
                  return;
                }
                if (!res || !res.data) {
                  this.handleError(
                    res.code ? res.code : null,
                    res.message ? res.message : null
                  );
                  return;
                }
                this.dialog.close(true);
              });
              return;
            }
            this.dialog.close(true);
          });
        // });
        return;
      }

      this.templateFieldConfigService
        .saveAllTemplateFieldConfig(
          [templateFieldConfig],
          this.dataDialog.templateId
        )
        .subscribe((response) => {
          if (response && response.code === ErrorCode.NotPermissionTemplate) {
            this.toastr.error(this.message.getMessage('messages.check_permission'));
            return;
          }
          if (!response || !response.data || !response.data.length) {
            if (response) {
              this.handleError(
                response.code ? response.code : null,
                response.message ? response.message : null
              );
              if(response.code === ErrorCode.MergeFieldAlreadyExist){
                this.mainFormGroup
                .get("mergeField")
                .setErrors({ mergeFieldExist: true });
              }
            }
            return;
          }
          this.dialog.close(true);
        });
      return;
    }
    if (
      !this.dataDialog.fieldConfig ||
      (!this.dataDialog.fieldConfig.parentId && fieldConfig.parentId)
    ) {
      fieldConfig.fieldConfigId = null;
      const parent = this.dataDialog.listFields.find(
        (field) => field.fieldConfigId === fieldConfig.parentId
      );
      fieldConfig.orderNo = parent.children.length + 1;
    }

    if (
      this.dataDialog.fieldConfig &&
      !this.dataDialog.fieldConfig.parentId &&
      fieldConfig.parentId
    ) {
      this.templateFieldConfigService
        .deleteTemplateFieldConfig(
          [this.dataDialog.fieldConfig.templateFieldConfigId]
        )
        .subscribe((res) => {
          if (res && res.code === ErrorCode.NotPermissionTemplate) {
            this.toastr.error(this.message.getMessage('messages.check_permission'));
            return;
          }
          if (!res || !res.success) {
            if (res) {
              this.handleError(
                res.code ? res.code : null,
                res.message ? res.message : null
              );
            }
            return;
          }
          // xu ly chuyen truong vao trong nhom
          const dataChange = [];
          const templateFieldConfigs = [];
          let lastIndex = null;

          // const templateFieldConfig: TemplateFieldConfig =
          //   TemplateFieldConfig.build();
          // templateFieldConfig.fieldConfig = fieldConfig;
          // templateFieldConfig.templateId = this.dataDialog.templateId;
          // templateFieldConfigs.push(templateFieldConfig);
          // thay doi stt cho cac truong sau truong thay doi
          this.dataDialog.listFields.forEach((item) => {
            if (item.orderNo > this.dataDialog.fieldConfig.orderNo) {
              const dataNew = item;
              --dataNew.orderNo;
              lastIndex = dataNew.orderNo;
              dataChange.push(dataNew);
            }
          });
          if (
            this.dataDialog.fieldConfig.group &&
            this.dataDialog.fieldConfig.children.length
          ) {
            if (!lastIndex) {
              lastIndex = this.dataDialog.listFields.length;
            }
            this.dataDialog.fieldConfig.children.forEach((item, index) => {
              item.parentId = null;
              item.orderNo = lastIndex + 1 + index;
              const templateFieldConfig: TemplateFieldConfig =
                TemplateFieldConfig.build();
              templateFieldConfig.templateId = this.dataDialog.templateId;
              templateFieldConfig.fieldConfig = item;
              templateFieldConfigs.push(templateFieldConfig);
            });
          }
          const apiForkJoin = [
            this.dcFieldConfigService.saveFieldConfig(
              [fieldConfig],
              this.dataDialog.templateId
            ),
          ];
          if (templateFieldConfigs.length) {
            apiForkJoin.push(
              this.templateFieldConfigService.saveAllTemplateFieldConfig(
                templateFieldConfigs,
                this.dataDialog.templateId
              )
            );
          }
          if (dataChange.length) {
            apiForkJoin.push(
              this.dcFieldConfigService.saveFieldConfig(
                dataChange,
                this.dataDialog.templateId
              )
            );
          }
          forkJoin(apiForkJoin).subscribe((res) => {
            if (!res || !res.length) {
              return;
            }
            this.dialog.close(true);
          });
        });
      return;
    }

    this.dcFieldConfigService
      .saveFieldConfig([fieldConfig], this.dataDialog.templateId)
      .subscribe((response) => {
        if (response && response.code === ErrorCode.NotPermissionTemplate) {
          this.toastr.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (!response || !response.data || !response.data.length) {
          if (response) {
            this.handleError(
              response.code ? response.code : null,
              response.message ? response.message : null
            );
          }
          return;
        }
        if (
          this.dataDialog.fieldConfig &&
          this.dataDialog.fieldConfig.group &&
          !fieldConfig.group &&
          this.dataDialog.fieldConfig.children.length
        ) {
          const templateFieldConfigs = [];
          this.dataDialog.fieldConfig.children.forEach((item, index) => {
            item.parentId = null;
            item.orderNo = this.dataDialog.listFields.length + 1 + index;
            const templateFieldConfig: TemplateFieldConfig =
              TemplateFieldConfig.build();
            templateFieldConfig.templateId = this.dataDialog.templateId;
            templateFieldConfig.fieldConfig = item;
            templateFieldConfigs.push(templateFieldConfig);
          });
          this.templateFieldConfigService
            .saveAllTemplateFieldConfig(
              templateFieldConfigs,
              this.dataDialog.templateId
            )
            .subscribe((res) => {
              if (res && res.code === ErrorCode.NotPermissionTemplate) {
                this.toastr.error(this.message.getMessage('messages.check_permission'));
                return;
              }
              if (!res || !res.data) {
                if (res) {
                  this.handleError(
                    res.code ? res.code : null,
                    res.message ? res.message : null
                  );
                }
                return;
              }
              this.dialog.close(true);
            });
          return;
        }
        this.dialog.close(true);
      });
  }

  cancel() {
    if (this.mainFormGroup.dirty) {
      const dialog = this.matDialog.open(WarningComponent, {
        data: this.message.getMessage("messages.config_is_change"),
        width: "40%",
      });
      dialog.afterClosed().subscribe((ref) => {
        if (!ref) {
          return;
        }
        this.dialog.close();
      });
    } else {
      this.dialog.close();
    }
  }

  // tinh so thu tu trong bang
  processFieldWithPosition(listField: Array<FieldConfig>): Array<any> {
    const fieldWithPosition: Array<any> = [];
    let index = 1;
    for (const field of listField) {
      if (!field.group) {
        const fieldCache: any = field;
        fieldCache.position = "C" + index;
        fieldWithPosition.push(fieldCache);
        this.listFields.push(field);
        index++;
      } else {
        const fieldParent: any = field;
        fieldParent.position = "C" + index;
        fieldWithPosition.push(fieldParent);
        index++;
        field.children.forEach((fieldChild) => {
          const fieldChildCache: any = fieldChild;
          fieldChildCache.position = "C" + index;
          fieldWithPosition.push(fieldChildCache);
          this.listFields.push(fieldChild);
          index++;
        });
      }
    }
    return fieldWithPosition;
  }

  // fill data tu model vao form
  mapModelToForm(fieldConfig: FieldConfig): void {
    const controls = this.mainFormGroup.controls;
    controls.isGroup.patchValue(fieldConfig.group ? fieldConfig.group : null);
    controls.isMultipleGroup.patchValue(
      fieldConfig.multiple ? fieldConfig.multiple : null
    );
    controls.name.patchValue(fieldConfig.name ? fieldConfig.name : null);
    controls.editorSignatureId.patchValue(fieldConfig.editorSignatureId ? fieldConfig.editorSignatureId : null);
    controls.mergeFieldStart.patchValue(
      fieldConfig.startGroup ? fieldConfig.startGroup : null
    );
    controls.mergeFieldEnd.patchValue(
      fieldConfig.endGroup ? fieldConfig.endGroup : null
    );
    if (fieldConfig.endGroup) {
      controls.nameGroup.patchValue(fieldConfig.endGroup.replace("END_", ""));
    }
    controls.note.patchValue(fieldConfig.note ? fieldConfig.note : null);
    controls.mergeField.patchValue(
      fieldConfig.mergeField ? fieldConfig.mergeField : null
    );
    controls.group.patchValue(
      fieldConfig.parentId ? fieldConfig.parentId : null
    );
    controls.type.patchValue(
      fieldConfig.type && fieldConfig.type.code ? fieldConfig.type.code : null
    );
    controls.dataType.patchValue(
      fieldConfig.dataType && fieldConfig.dataType.code
        ? fieldConfig.dataType.code
        : null
    );
    controls.mergeFieldStart.patchValue(
      fieldConfig.startGroup ? fieldConfig.startGroup : null
    );
    controls.mergeFieldEnd.patchValue(
      fieldConfig.endGroup ? fieldConfig.endGroup : null
    );

    if (
      fieldConfig.dataType &&
      fieldConfig.dataType.code === this.DATA_TYPE_REF_CUSTOMER
    ) {
      this.relatedField = this.listField.filter((item) => {
        return item.category && item.category.code === "customer";
      });
    } else if (
      fieldConfig.dataType &&
      fieldConfig.dataType.code === this.DATA_TYPE_REF
    ) {
      this.relatedField = this.listField.filter((item) => {
        return (
          item.type &&
          (item.type.code === this.FIELD_TYPE_COMBOBOX ||
            item.type.code === this.FIELD_TYPE_RADIO) &&
          item.dataType &&
          item.dataType.code === this.DATA_TYPE_SELECT
        );
      });
    } else {
      this.relatedField = this.listField;
    }
    if (
      fieldConfig.type &&
      fieldConfig.type.code === HandsontableFieldTypeContrants.date
    ) {
      controls.defaultValue.patchValue(
        fieldConfig.defaultValue
          ? moment(fieldConfig.defaultValue, "DD/MM/YYYY").toDate()
          : null
      );
    } else {
      controls.defaultValue.patchValue(
        fieldConfig.defaultValue ? fieldConfig.defaultValue : null
      );
    }
    controls.isHidden.patchValue(fieldConfig.hide ? fieldConfig.hide : null);
    if (
      fieldConfig.dataType &&
      fieldConfig.dataType.code !== this.DATA_TYPE_REF
    ) {
      controls.category.patchValue(
        fieldConfig.category && fieldConfig.category.categoryId
          ? fieldConfig.category.categoryId
          : null
      );
      controls.refCategory.patchValue(
        fieldConfig.refCategoryField &&
          fieldConfig.refCategoryField.category &&
          fieldConfig.refCategoryField.category.categoryId
          ? fieldConfig.refCategoryField.category.categoryId
          : null
      );
    } else {
      controls.refCategory.patchValue(
        fieldConfig.category && fieldConfig.category.categoryId
          ? fieldConfig.category.categoryId
          : null
      );
    }
    controls.fixedFunction.patchValue(
      fieldConfig.fixedFunction && fieldConfig.fixedFunction.code
        ? fieldConfig.fixedFunction.code
        : null
    );

    if (fieldConfig.fixedFunction && fieldConfig.fixedFunction.code) {
      if (fieldConfig.fixedFunction.code === this.NUMBER_TO_MONEY_TEXT) {
        // const arrayFixedFieldCode = fieldConfig.fixedFieldCode
        //   ? fieldConfig.fixedFieldCode.split("-")
        //   : [];
        controls.fixedFieldCode.patchValue(
          fieldConfig.fixedFieldCode
            ? fieldConfig.fixedFieldCode
            : null
        );
        controls.fixedMoneyFieldCode.patchValue(
          fieldConfig.defaultValue
            ? fieldConfig.defaultValue
            : null
        );
        controls.defaultValue.patchValue(null);
        this.dcFieldConfigService.getDataCategoryCurrency().subscribe((res) => {
          if (!res || !res.data) {
            return;
          }
          this.listMoneyData = res.data;
        });
      } else {
        controls.fixedFieldCode.patchValue(
          fieldConfig.fixedFieldCode ? fieldConfig.fixedFieldCode : null
        );
      }
    }
    if (fieldConfig.fixedFunction && fieldConfig.fixedFunction.code) {
      if (fieldConfig.fixedFunction.code === "SUM") {
        this.fixedFields = this.listFields.filter((item) => {
          return (
            item.type &&
            (item.type.code === this.moneyFormat ||
              item.type.code === this.number)
          );
        });
      } else {
        this.fixedFields = this.listFields.filter((item) => {
          return (
            (item.type &&
              (item.type.code === this.moneyFormat ||
                item.type.code === this.number)) ||
            (item.fixedFunction && item.fixedFunction.code === "SUM")
          );
        });
      }
    }

    controls.formula.patchValue(
      fieldConfig.formula
        ? this.changeFormulaWithCodeToCol(fieldConfig.formula)
        : null
    );
    controls.relatedFieldDataCode.patchValue(
      fieldConfig.relatedFieldDataCode ? fieldConfig.relatedFieldDataCode : null
    );

    if (
      fieldConfig.refCategoryField &&
      fieldConfig.refCategoryField.category &&
      fieldConfig.refCategoryField.category.categoryId
    ) {
      this.dcFieldConfigService
        .getCategoryFields(fieldConfig.refCategoryField.category.categoryId)
        .subscribe((response) => {
          if (response && response.code === ErrorCode.NotPermissionTemplate) {
            this.toastr.error(this.message.getMessage('messages.check_permission'));
            return;
          }
          if (!response || !response.data) {
            this.listCategoryFields = [];
            return;
          }
          this.listCategoryFields = response.data;
          this.searchCategoryFieldCtrl.patchValue("");
        });
    }
    controls.refCategoryField.patchValue(
      fieldConfig.refCategoryField &&
        fieldConfig.refCategoryField.categoryFieldId
        ? fieldConfig.refCategoryField.categoryFieldId
        : null
    );
    controls.relatedFieldCode.patchValue(
      fieldConfig.relatedFieldCode ? fieldConfig.relatedFieldCode : null
    );
    if (fieldConfig.validations && fieldConfig.validations.length) {
      fieldConfig.validations.forEach((validation) => {
        switch (validation.code) {
          case "REQUIRED":
            controls.isRequired.patchValue(
              validation.validationValue
                ? JSON.parse(validation.validationValue)
                : null
            );
            break;
          case "MAXLENGTH":
            controls.maxLength.patchValue(
              validation.validationValue ? validation.validationValue : null
            );
            break;
          case "MINLENGTH":
            controls.minLength.patchValue(
              validation.validationValue ? validation.validationValue : null
            );
            break;
          default:
            break;
        }
      });
    }
    if (fieldConfig.dataType && fieldConfig.dataType.code) {
      switch (fieldConfig.dataType.code) {
        case this.DATA_TYPE_REF_CUSTOMER:
          this.dcFieldConfigService
            .getCategoryFields(1)
            .subscribe((response) => {
              if (response && response.code === ErrorCode.NotPermissionTemplate) {
                this.toastr.error(this.message.getMessage('messages.check_permission'));
                return;
              }
              if (!response || !response.data) {
                this.listCategoryFields = [];
                return;
              }
              this.listCategoryFields = response.data;
              this.searchCategoryFieldCtrl.patchValue("");
            });
          break;
        case this.DATA_TYPE_REF_ENTERPRISE:
          this.dcFieldConfigService
            .getCategoryFields(2)
            .subscribe((response) => {
              if (response && response.code === ErrorCode.NotPermissionTemplate) {
                this.toastr.error(this.message.getMessage('messages.check_permission'));
                return;
              }
              if (!response || !response.data) {
                this.listCategoryFields = [];
                return;
              }
              this.listCategoryFields = response.data;
              this.searchCategoryFieldCtrl.patchValue("");
            });
          break;
        case this.DATA_TYPE_CURRENCY:
          this.dcFieldConfigService
            .getDataCategoryCurrency()
            .subscribe((res) => {
              if (res && res.code === ErrorCode.NotPermissionTemplate) {
                this.toastr.error(this.message.getMessage('messages.check_permission'));
                return;
              }
              if (!res || !res.data) {
                return;
              }
              this.listDataCategories = res.data.map((data) => {
                data.value = data.name;
                return data;
              });
            });
          this.listCategories = this.listCategoriesCache
            .filter((item) => {
              return item.code === "currency";
            })
            .sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
          break;
        case this.DATA_TYPE_SELECT:
          if (fieldConfig.category && fieldConfig.category.categoryId !== 1) {
            this.dcFieldConfigService
              .getDataCategories(fieldConfig.category.categoryId)
              .subscribe((res) => {
                if (!res) {
                  return;
                }
                this.listDataCategories = res.data;
              });
            if (fieldConfig.type.code === this.FIELD_TYPE_COMBOBOX) {
              this.listCategories = this.listCategoriesCache
                .filter((item) => {
                  return item.code !== "currency" && item.code !== "enterprise";
                })
                .sort((a, b) => {
                  return a.name.localeCompare(b.name);
                });
            } else {
              this.listCategories = this.listCategoriesCache
                .filter((item) => {
                  return (
                    item.code !== "currency" &&
                    item.code !== "enterprise" &&
                    item.code !== "customer"
                  );
                })
                .sort((a, b) => {
                  return a.name.localeCompare(b.name);
                });
            }
          }
          break;
        case this.DATA_TYPE_REF:
          if (fieldConfig.relatedFieldCode) {
            const field = this.listFields.find(
              (item) => item.code === fieldConfig.relatedFieldCode
            );
            if (field && field.category && field.category.categoryId) {
              this.dcFieldConfigService
                .getCategoryByParent(field.category.categoryId)
                .subscribe((res) => {
                  if (res && res.code === ErrorCode.NotPermissionTemplate) {
                    this.toastr.error(this.message.getMessage('messages.check_permission'));
                    return;
                  }
                  if (!res || !res.data) {
                    return;
                  }
                  this.listCategories = res.data.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                  });
                });
            }
          }
          break;
        default:
          break;
      }
    }
  }

  // xu ly data tu form
  mapDataFormToModel(): FieldConfig {
    let fieldConfig = FieldConfig.build();
    if (this.dataDialog.fieldConfig) {
      fieldConfig = JSON.parse(JSON.stringify(this.dataDialog.fieldConfig));
    }
    const controls = this.mainFormGroup.controls;
    fieldConfig.group = controls.isGroup.value;
    fieldConfig.multiple = controls.isMultipleGroup.value;
    fieldConfig.name = controls.name.value;
    fieldConfig.startGroup = controls.mergeFieldStart.value;
    fieldConfig.endGroup = controls.mergeFieldEnd.value;
    fieldConfig.note = controls.note.value;
    fieldConfig.mergeField = controls.mergeField.value;
    fieldConfig.parentId = controls.group.value;
    fieldConfig.category = controls.category.value;
    fieldConfig.editorSignatureId = controls.editorSignatureId.value;
    if (controls.type.value) {
      const fieldType = this.listFieldTypes.find(
        (type) => type.code === controls.type.value
      );
      fieldConfig.type = fieldType;
    }
    if (controls.dataType.value) {
      const dataType = this.listDataTypes.find(
        (dataT) => dataT.code === controls.dataType.value
      );
      fieldConfig.dataType = dataType;
    }
    if (
      controls.defaultValue.value &&
      fieldConfig.type.code === HandsontableFieldTypeContrants.moneyFormat
    ) {
      fieldConfig.defaultValue = controls.defaultValue.value.replaceAll(
        ",",
        ""
      );
    } else if (
      controls.defaultValue.value &&
      fieldConfig.type.code === HandsontableFieldTypeContrants.date
    ) {
      fieldConfig.defaultValue = moment(controls.defaultValue.value).format(
        "DD/MM/YYYY"
      );
    } else {
      fieldConfig.defaultValue = controls.defaultValue.value
        ? controls.defaultValue.value.trim()
        : null;
    }
    fieldConfig.hide = controls.isHidden.value;
    if (controls.category.value) {
      const category = this.listCategoriesCache.find(
        (cate) => cate.categoryId === controls.category.value
      );
      fieldConfig.category = category;
    }

    if (controls.fixedFunction.value) {
      const fixedFunction = this.listFixedFunctions.find(
        (func) => func.code === controls.fixedFunction.value
      );
      fieldConfig.fixedFunction = fixedFunction;
      if (controls.fixedFunction.value === this.NUMBER_TO_MONEY_TEXT) {
        fieldConfig.fixedFieldCode =
          controls.fixedFieldCode.value;
        fieldConfig.defaultValue = controls.fixedMoneyFieldCode.value;
      } else {
        fieldConfig.fixedFieldCode = controls.fixedFieldCode.value;
      }
    } else {
      fieldConfig.fixedFunction = null;
      fieldConfig.fixedFieldCode = null;
    }
    if (controls.formula.value) {
      fieldConfig.formula = this.changeFormulaWithColToCode(
        controls.formula.value
      );
    } else {
      fieldConfig.formula = null;
    }
    fieldConfig.relatedFieldDataCode = controls.relatedFieldDataCode.value;
    fieldConfig.relatedFieldCode = controls.relatedFieldCode.value;
    if (controls.refCategoryField.value) {
      const categoryField = this.listCategoryFields.find(
        (cf) => cf.categoryFieldId === controls.refCategoryField.value
      );
      fieldConfig.refCategoryField = categoryField;
    }

    if (
      controls.dataType.value === this.DATA_TYPE_REF &&
      controls.refCategory.value
    ) {
      const category = this.listCategoriesCache.find(
        (cate) => cate.categoryId === controls.refCategory.value
      );
      fieldConfig.category = category;
    }
    // them object validation
    if (fieldConfig.validations.find((item) => item.code === "REQUIRED")) {
      const temp = fieldConfig.validations.find(
        (item) => item.code === "REQUIRED"
      );
      temp.validationValue =
        controls.isRequired.value !== null
          ? controls.isRequired.value.toString()
          : "false";
    } else if (controls.isRequired.value) {
      const validationRequired = FieldValidation.build();
      validationRequired.code = "REQUIRED";
      validationRequired.name = "Bắt buộc nhập";
      validationRequired.validationValue = controls.isRequired.value.toString();
      fieldConfig.validations.push(validationRequired);
    }

    if (
      fieldConfig.validations.filter((item) => item.code === "MINLENGTH").length
    ) {
      let temp: FieldValidation = fieldConfig.validations.find(
        (item) => item.code === "MINLENGTH"
      );
      if (temp.validationValue !== controls.minLength.value) {
        temp.validationValue =
          controls.minLength.value !== null
            ? controls.minLength.value.toString()
            : null;
      }
    } else {
      if (controls.minLength.value !== null) {
        const validationMinLength = FieldValidation.build();
        validationMinLength.code = "MINLENGTH";
        validationMinLength.name = "Độ dài tối thiểu";
        validationMinLength.validationValue =
          controls.minLength.value.toString();
        fieldConfig.validations.push(validationMinLength);
      }
    }

    if (
      fieldConfig.validations.filter((item) => item.code === "MAXLENGTH").length
    ) {
      let temp: FieldValidation = fieldConfig.validations.find(
        (item) => item.code === "MAXLENGTH"
      );
      if (temp.validationValue !== controls.maxLength.value) {
        temp.validationValue =
          controls.maxLength.value !== null
            ? controls.maxLength.value.toString()
            : null;
      }
    } else {
      if (controls.maxLength.value !== null) {
        const validationMaxLength = FieldValidation.build();
        validationMaxLength.code = "MAXLENGTH";
        validationMaxLength.name = "Độ dài tối đa";
        validationMaxLength.validationValue =
          controls.maxLength.value.toString();
        fieldConfig.validations.push(validationMaxLength);
      }
    }

    return fieldConfig;
  }

  changeFormulaWithColToCode(formula: string): string {
    // loai bo chuoi
    const checkText = `\"[\d\wÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s\!\#\$\%\&\'\(\)\*\+\,\\\.\/\:\;\<\=\>\?\@\[\]\^\_\`\{\|\}\~\…\-\”\“]*\"`;
    const regexString = new RegExp(checkText, "g");
    const listString = formula.match(regexString);
    if (listString && listString.length) {
      listString.forEach((item) => {
        formula = formula.replace(item, "<*>");
      });
    }
    // thay vi tri o bang code truong
    const regex = /([ABC]{1}[\d]{1,4})/g;
    const listCol = formula.match(regex);
    if (!listCol || !listCol.length) {
      if (listString && listString.length) {
        listString.forEach((item) => {
          formula = formula.replace("<*>", item);
        });
      }
      return formula;
    }
    listCol.forEach((col) => {
      formula = formula.replace(col, "<*col*>");
    });
    listCol.forEach((col) => {
      let colPosition;
      if (col.substring(0, 1) === "A") {
        colPosition = col.replace("A", "C");
      } else if (col.substring(0, 1) === "B") {
        colPosition = col.replace("B", "C");
      } else {
        colPosition = col;
      }
      const fieldConfig = this.listFieldWithPosition.find(
        (fc) => fc.position === colPosition
      );
      if (fieldConfig) {
        formula = formula.replace(
          "<*col*>",
          "<" +
          (col.substring(0, 1) === "A"
            ? "*"
            : col.substring(0, 1) === "B"
              ? "**"
              : "") +
          fieldConfig.code +
          ">"
        );
      }
    });
    if (listString && listString.length) {
      listString.forEach((item) => {
        formula = formula.replace("<*>", item);
      });
    }
    return formula;
  }

  changeFormulaWithCodeToCol(formula: string): string {
    // thay code bang o
    const regex = /<[*A-Z0-9_]{2,}>/g;
    const listCode = formula.match(regex);
    if (!listCode || !listCode.length) {
      return formula;
    }
    listCode.forEach((code) => {
      let codeNew;
      if (code.substring(1, 2) === "*" && code.substring(2, 3) !== "*") {
        codeNew = code.slice(2, code.length - 1);
      } else if (code.substring(1, 3) === "**") {
        codeNew = code.slice(3, code.length - 1);
      } else {
        codeNew = code.slice(1, code.length - 1);
      }
      const fieldConfig = this.listFieldWithPosition.find(
        (fc) => fc.code === codeNew
      );
      if (fieldConfig) {
        let colPosition;
        if (code.substring(1, 2) === "*" && code.substring(2, 3) !== "*") {
          colPosition = fieldConfig.position.replace("C", "A");
        } else if (code.substring(1, 3) === "**") {
          colPosition = fieldConfig.position.replace("C", "B");
        } else {
          colPosition = fieldConfig.position;
        }
        formula = formula.replace(code, colPosition);
      }
    });
    return formula;
  }

  initData() {
    forkJoin([
      this.dcFieldConfigService.getDataTypes(),
      this.dcFieldConfigService.getFieldTypes(),
      this.dcFieldConfigService.getFixedFunctions(),
      this.dcFieldConfigService.getCategories(),
    ]).subscribe((response) => {
      if (!response || !response.length) {
        return;
      }
      // list dataType
      this.listDataTypes = response[0].data.filter(item => {
        return item.code !== this.DATA_TYPE_CURRENCY;
      });
      this.dcFieldConfigService.dataType = response[0].data;

      // list fieldType
      this.listFieldTypes = response[1].data;
      this.dcFieldConfigService.fieldType = response[1].data;

      // list fixedFunction
      this.listFixedFunctions = response[2].data;
      // list categories
      this.listCategories = response[3].data
        .filter((item) => {
          return item.code !== "currency" && item.code !== "enterprise" && item.code !== "customer";
        })
        .sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      this.listCategoriesCache = response[3].data;

      const customer = this.listCategoriesCache.find(
        (item) => item.code === "customer"
      );
      this.customerCategoryId =
        customer && customer.categoryId ? customer.categoryId : null;

        const contract_code = this.listCategoriesCache.find(
          (item) => item.code === "contract_code"
        );
        this.customerCodeCategoryId =
        contract_code && contract_code.categoryId ? contract_code.categoryId : null;
      if (
        this.dataDialog.fieldConfig &&
        this.dataDialog.fieldConfig.dataType &&
        this.dataDialog.fieldConfig.dataType.code
      ) {
        switch (this.dataDialog.fieldConfig.dataType.code) {
          case this.DATA_TYPE_INPUT:
          case this.DATA_TYPE_FORMULA:
          case this.DATA_TYPE_REF_CUSTOMER:
          case this.DATA_TYPE_REF_ENTERPRISE:
          case this.DATA_TYPE_REF:
            this.listTypes = this.listFieldTypes.filter((item) => {
              return !this.listFieldTypeDefine.includes(item.code);
            });
            break;
          case this.DATA_TYPE_SELECT:
            this.listTypes = this.listFieldTypes.filter((item) => {
              return this.listFieldTypeDefine.includes(item.code);
            });
            if (
              this.dataDialog.fieldConfig.type.code === this.FIELD_TYPE_COMBOBOX
            ) {
              this.listCategories = this.listCategoriesCache
                .filter((item) => {
                  return item.code !== "currency" && item.code !== "enterprise" && item.code !== "customer";
                })
                .sort((a, b) => {
                  return a.name.localeCompare(b.name);
                });
            } else {
              this.listCategories = this.listCategoriesCache
                .filter((item) => {
                  return (
                    item.code !== "currency" &&
                    item.code !== "enterprise" &&
                    item.code !== "customer"
                  );
                })
                .sort((a, b) => {
                  return a.name.localeCompare(b.name);
                });
            }
            break;
          case this.DATA_TYPE_CURRENCY:
            this.listCategories = this.listCategoriesCache
              .filter((item) => {
                return item.code === "currency";
              })
              .sort((a, b) => {
                return a.name.localeCompare(b.name);
              });
            break;
          default:
            break;
        }
      } else {
        this.listTypes = this.listFieldTypes.filter((item) => {
          return !this.listFieldTypeDefine.includes(item.code);
        });
      }
    });
  }

  // start su kien

  // chon truong vao cong thuc
  onClickField(field: any) {
    let formula = this.mainFormGroup.get("formula").value
      ? this.mainFormGroup.get("formula").value
      : "";
    formula = `${formula}${field.position}`;
    this.mainFormGroup.get("formula").patchValue(formula);
  }

  // xoa du lieu khi thay doi la group hay k
  onChangeIsGroup(event: any): void {
    this.mainFormGroup.markAsUntouched();
    const controls = this.mainFormGroup.controls;
    if (event.checked) {
      controls.mergeField.patchValue(null);
      controls.group.patchValue(null);
      controls.dataType.patchValue(null);
      controls.type.patchValue(null);
      controls.defaultValue.patchValue(null);
      controls.isHidden.patchValue(null);
      controls.isRequired.patchValue(null);
      controls.minLength.patchValue(null);
      controls.maxLength.patchValue(null);
      controls.category.patchValue(null);
      controls.fixedFieldCode.patchValue(null);
      controls.editorSignatureId.patchValue(null);
      controls.refCategoryField.patchValue(null);
      controls.relatedFieldDataCode.patchValue(null);
      controls.refCategory.patchValue(null);
      controls.fixedFunction.patchValue(null);
      controls.relatedFieldCode.patchValue(null);
    } else {
      controls.isMultipleGroup.patchValue(null);
      controls.mergeFieldStart.patchValue(null);
      controls.mergeFieldEnd.patchValue(null);
    }
    this.mainFormGroup.updateValueAndValidity();
  }

  // xoa cac truong khi thay doi kieu du lieu
  onChangeDataType(event: any): void {
    const controls = this.mainFormGroup.controls;
    controls.type.patchValue(null);
    controls.defaultValue.patchValue(null);
    controls.category.patchValue(null);
    controls.fixedFieldCode.patchValue(null);
    controls.editorSignatureId.patchValue(null);
    controls.refCategoryField.patchValue(null);
    controls.relatedFieldDataCode.patchValue(null);
    controls.refCategory.patchValue(null);
    controls.fixedFunction.patchValue(null);
    controls.relatedFieldCode.patchValue(null);
    controls.formula.patchValue(null);
    controls.fixedMoneyFieldCode.patchValue(null);
    if (
      event.value &&
      (event.value === this.DATA_TYPE_REF_CUSTOMER ||
        event.value === this.DATA_TYPE_REF_ENTERPRISE)
    ) {
      const categoryId = event.value === this.DATA_TYPE_REF_CUSTOMER ? 1 : 2;
      this.dcFieldConfigService
        .getCategoryFields(categoryId)
        .subscribe((response) => {
          if (response && response.code === ErrorCode.NotPermissionTemplate) {
            this.toastr.error(this.message.getMessage('messages.check_permission'));
            return;
          }
          if (!response || !response.data) {
            this.listCategoryFields = [];
            return;
          }
          this.listCategoryFields = response.data;
          this.searchCategoryFieldCtrl.patchValue("");
        });
      this.listTypes = this.listFieldTypes.filter((type) => {
        return !this.listFieldTypeDefine.includes(type.code);
      });
      this.relatedField = this.listField.filter((item) => {
        return item.category && item.category.code === "customer";
      });
      this.listCategories = this.listCategoriesCache.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
    if (event.value === this.DATA_TYPE_REF) {
      this.relatedField = this.listField.filter((item) => {
        return (
          item.type &&
          (item.type.code === this.FIELD_TYPE_COMBOBOX ||
            item.type.code === this.FIELD_TYPE_RADIO) &&
          item.dataType &&
          item.dataType.code === this.DATA_TYPE_SELECT &&
          item.category &&
          item.category.code !== "customer"
        );
      });
      this.listTypes = this.listFieldTypes.filter((type) => {
        return !this.listFieldTypeDefine.includes(type.code);
      });
      this.listCategories = [];
      controls.refCategory.patchValue(null);
      controls.type.patchValue(this.FIELD_TYPE_TEXTBOX);
    } else if (event.value === this.DATA_TYPE_SELECT) {
      this.listTypes = this.listFieldTypes.filter((type) => {
        return this.listFieldTypeDefine.includes(type.code);
      });
      this.dcFieldConfigService.getCategories().subscribe((res) => {
        if (res && res.code === ErrorCode.NotPermissionTemplate) {
          this.toastr.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (!res || !res.data) {
          this.listCategories = this.listCategoriesCache
            .filter((category) => {
              return (
                category.code !== "enterprise" && category.code !== "currency" && category.code !== "customer"
              );
            })
            .sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
          return;
        }
        this.listCategoriesCache = res.data;
        this.listCategories = this.listCategoriesCache
          .filter((category) => {
            return (
              category.code !== "enterprise" && category.code !== "currency" && category.code !== "customer"
            );
          })
          .sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
        controls.category.patchValue(this.listCategories.length ? this.listCategories[0].categoryId : null);
        this.onChangeCategories({value: this.listCategories.length ? this.listCategories[0].categoryId : null});
      });
      controls.type.patchValue(this.FIELD_TYPE_COMBOBOX);
    } else if (event.value === this.DATA_TYPE_CURRENCY) {
      this.listTypes = this.listFieldTypes.filter((type) => {
        return this.listFieldTypeDefine.includes(type.code);
      });
      this.listCategories = this.listCategoriesCache.filter((category) => {
        return category.code === "currency";
      });
      this.dcFieldConfigService.getDataCategoryCurrency().subscribe((res) => {
        if (res && res.code === ErrorCode.NotPermissionTemplate) {
          this.toastr.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (!res || !res.data) {
          return;
        }
        this.listDataCategories = res.data.map((data) => {
          if (data.code === "VND") {
            controls.defaultValue.patchValue(data.name);
          }
          data.value = data.name;
          return data;
        });
      });
      const currency = this.listCategories.find(
        (item) => item.code === "currency"
      );
      controls.type.patchValue(this.FIELD_TYPE_COMBOBOX);
      controls.category.patchValue(currency ? currency.categoryId : null);
    } else if (event.value === this.DATA_TYPE_CUSTOMER) {
      controls.type.patchValue(this.FIELD_TYPE_COMBOBOX);
      controls.category.patchValue(this.customerCategoryId);
    } else if (event.value === this.DATA_TYPE_CONTRACT_CODE) {
      controls.type.patchValue(this.DATA_TYPE_CONTRACT_CODE);
      controls.category.patchValue(this.customerCodeCategoryId);
    } else if (event.value === this.DATA_TYPE_FIXED) {
      this.fixedFields = this.listFields.filter((item) => {
        return (
          item.type &&
          (item.type.code === this.moneyFormat ||
            item.type.code === this.number)
        );
      });
      controls.type.patchValue(this.FIELD_TYPE_TEXTBOX);
      controls.fixedFunction.patchValue("SUM");
    } else if (event.value) {
      this.listTypes = this.listFieldTypes.filter((type) => {
        return !this.listFieldTypeDefine.includes(type.code);
      });
      controls.type.patchValue(this.FIELD_TYPE_TEXTBOX);
    }
  }

  // xu ly khi thay doi dinh dang nhap
  onChangeFieldType(): void {
    const controls = this.mainFormGroup.controls;
    controls.defaultValue.patchValue(null);
    controls.category.patchValue(null);
    controls.relatedFieldDataCode.patchValue(null);
    controls.defaultValue.clearValidators();
    controls.defaultValue.setValidators(this.defaultValueValidation());
    controls.defaultValue.updateValueAndValidity();
    if (controls.type.value === this.FIELD_TYPE_COMBOBOX) {
      const customer = this.listCategoriesCache.find(
        (item) => item.code === "customer"
      );
      controls.category.patchValue(
        customer && customer.categoryId ? customer.categoryId : null
      );
      this.dcFieldConfigService.getCategories().subscribe((res) => {
        if (!res || !res.data) {
          this.listCategories = this.listCategoriesCache
            .filter((category) => {
              return (
                category.code !== "enterprise" && category.code !== "currency" && category.code !== "customer"
              );
            })
            .sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
          return;
        }
        this.listCategoriesCache = res.data;
        this.listCategories = this.listCategoriesCache
          .filter((category) => {
            return (
              category.code !== "enterprise" && category.code !== "currency" && category.code !== "customer"
            );
          })
          .sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
      });
    } else if (
      controls.type.value === this.FIELD_TYPE_CHECKBOX ||
      controls.type.value === this.FIELD_TYPE_RADIO
    ) {
      this.dcFieldConfigService.getCategories().subscribe((res) => {
        if (!res || !res.data) {
          this.listCategories = this.listCategoriesCache
            .filter((category) => {
              return (
                category.code !== "enterprise" &&
                category.code !== "currency" &&
                category.code !== "customer"
              );
            })
            .sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
          if (this.listCategories.length) {
            controls.category.patchValue(
              this.listCategories[0].categoryId
                ? this.listCategories[0].categoryId
                : null
            );
          } else {
            controls.category.patchValue(null);
          }
          return;
        }
        this.listCategoriesCache = res.data;
        this.listCategories = this.listCategoriesCache
          .filter((category) => {
            return (
              category.code !== "enterprise" &&
              category.code !== "currency" &&
              category.code !== "customer"
            );
          })
          .sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
        if (this.listCategories.length) {
          controls.category.patchValue(
            this.listCategories[0].categoryId
              ? this.listCategories[0].categoryId
              : null
          );
        } else {
          controls.category.patchValue(null);
        }
      });
      this.listCategories = this.listCategoriesCache
        .filter((category) => {
          return (
            category.code !== "enterprise" &&
            category.code !== "currency" &&
            category.code !== "customer"
          );
        })
        .sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      if (this.listCategories.length) {
        controls.category.patchValue(
          this.listCategories[0].categoryId
            ? this.listCategories[0].categoryId
            : null
        );
        this.dcFieldConfigService
          .getDataCategories(this.listCategories[0].categoryId)
          .subscribe((resCate) => {
            if (!resCate || !resCate.data) {
              return;
            }
            this.listDataCategories = resCate.data;
          });
      } else {
        controls.category.patchValue(null);
      }
    }

    // if (controls.type.value === HandsontableFieldTypeContrants.moneyFormat) {
    //   document.getElementById("defaultValue").setAttribute("maxlength", "18");
    // } else if (controls.type.value === HandsontableFieldTypeContrants.phone) {
    //   document.getElementById("defaultValue").setAttribute("maxlength", "20");
    // } else if (controls.type.value === HandsontableFieldTypeContrants.date) {
    //   document.getElementById("defaultValue").setAttribute("maxlength", "10");
    // } else {
    //   document.getElementById("defaultValue").setAttribute("maxlength", "200");
    // }
  }

  // load data cho truong tham chieu
  onChangeRefCategory(event: any): void {
    if (event.value) {
      this.mainFormGroup.get("refCategoryField").patchValue(null);
      this.dcFieldConfigService
        .getCategoryFields(event.value)
        .subscribe((response) => {
          if (!response || !response.data) {
            this.listCategoryFields = [];
            return;
          }
          this.listCategoryFields = response.data;
          this.searchCategoryFieldCtrl.patchValue("");
        });
    }
  }

  // load xoa du lieu bat buoc nhap
  onChangeIsHidden(event: any): void {
    if (event.checked) {
      this.mainFormGroup.get("isRequired").patchValue(false);
    }
  }

  // loc truong tham chieu cho kieu co dinh
  onChangeFixedFunction(event: any): void {
    this.mainFormGroup.controls.type.patchValue(this.FIELD_TYPE_TEXTBOX);
    this.mainFormGroup.get("fixedMoneyFieldCode").patchValue(null);
    if (event.value === "SUM") {
      this.fixedFields = this.listFields.filter((item) => {
        return (
          item.type &&
          (item.type.code === this.moneyFormat ||
            item.type.code === this.number)
        );
      });
    } else {
      this.fixedFields = this.listFields.filter((item) => {
        return (
          (item.type &&
            (item.type.code === this.moneyFormat ||
              item.type.code === this.number)) ||
          (item.fixedFunction && item.fixedFunction.code === "SUM")
        );
      });
      if (event.value === this.NUMBER_TO_MONEY_TEXT) {
        this.dcFieldConfigService.getDataCategoryCurrency().subscribe((res) => {
          if (!res || !res.data) {
            return;
          }
          this.listMoneyData = res.data;
        });
      }
    }
  }

  onChangeCategories(event) {
    if (event.value && (event.value !== this.customerCategoryId || event.value !== this.customerCodeCategoryId)) {
      this.dcFieldConfigService
        .getDataCategories(event.value)
        .subscribe((res) => {
          if (!res || !res.data) {
            return;
          }
          this.listDataCategories = res.data;
        });
    }
  }

  onChangeRelatedFieldCode(event) {
    const controls = this.mainFormGroup.controls;
    if (event.value && controls.dataType.value === this.DATA_TYPE_REF) {
      controls.refCategory.patchValue(null);
      const field = this.listFields.find((item) => item.code === event.value);
      if (field && field.category && field.category.categoryId) {
        this.dcFieldConfigService
          .getCategoryByParent(field.category.categoryId)
          .subscribe((res) => {
            if (!res || !res.data) {
              return;
            }
            this.listCategories = res.data.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
          });
      }
    }
  }
  // end su kien

  // start custom validation
  // validate kieu du lieu
  dataTypeValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const isGroup = this.mainFormGroup.get("isGroup").value;
        if (!isGroup && !control.value) {
          return { required: true };
        }
        return null;
      }
      return null;
    };
  }

  // validate dinh dang
  fieldTypeValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const dataType = this.mainFormGroup.get("dataType").value;
        if (dataType && dataType !== this.DATA_TYPE_FIXED && !control.value) {
          return { required: true };
        }
        return null;
      }
      return null;
    };
  }

  // validate danh muc (yeu cau khi dinh dang là combobox, checkbox, radio)
  categoryValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const fieldType = this.mainFormGroup.get("type").value;
        const dataType = this.mainFormGroup.get("dataType").value;
        if (
          fieldType &&
          dataType &&
          (dataType === this.DATA_TYPE_SELECT ||
            dataType === this.DATA_TYPE_CURRENCY) &&
          (fieldType === this.FIELD_TYPE_COMBOBOX ||
            fieldType === this.FIELD_TYPE_CHECKBOX ||
            fieldType === this.FIELD_TYPE_RADIO) &&
          !control.value
        ) {
          return { required: true };
        }
        return null;
      }
      return null;
    };
  }

  // validate cho 2 truong kieu co dinh (kieu co dinh, truong tham chieu)
  fixedValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const dataType = this.mainFormGroup.get("dataType").value;
        if (dataType && dataType === this.DATA_TYPE_FIXED && !control.value) {
          return { required: true };
        }
        return null;
      }
      return null;
    };
  }

  // validate relatedField cho kieu tham chieu ben khach hang
  relatedFieldCodeValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const dataType = this.mainFormGroup.get("dataType").value;
        if (
          dataType &&
          (dataType === this.DATA_TYPE_REF_CUSTOMER ||
            dataType === this.DATA_TYPE_REF) &&
          !control.value
        ) {
          return { required: true };
        }
        return null;
      }
      return null;
    };
  }

  // validate refCategoryField cho cac kieu tham chieu
  refCategoryFieldValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const dataType = this.mainFormGroup.get("dataType").value;
        if (
          dataType &&
          (dataType === this.DATA_TYPE_REF_CUSTOMER ||
            dataType === this.DATA_TYPE_REF_ENTERPRISE) &&
          !control.value
        ) {
          return { required: true };
        }
        return null;
      }
      return null;
    };
  }

  minLengthValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const minLength = this.mainFormGroup.get("minLength").value;
        const maxLength = this.mainFormGroup.get("maxLength").value;
        if (Number(minLength) > 4000 || Number(minLength) < 0) {
          return { checkMinLength: true };
        }
        if (maxLength !== null) {
          this.mainFormGroup.get("maxLength").updateValueAndValidity();
        }
        return null;
      }
      return null;
    };
  }

  maxLengthValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const minLength = this.mainFormGroup.get("minLength").value;
        const maxLength = this.mainFormGroup.get("maxLength").value;
        if (Number(maxLength) > 4000 || Number(maxLength) < 0) {
          return { checkMaxLength: true };
        } else if (
          minLength !== null &&
          maxLength !== null &&
          Number(maxLength) < Number(minLength)
        ) {
          return { checkGreater: true };
        }
        return null;
      }
      return null;
    };
  }

  defaultValueValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const type = this.mainFormGroup.get("type").value;
        if (control.value) {
          if (type !== "date") {
            if (control.value.substring(0, 1) === "=") {
              return null;
            }
          }
          switch (type) {
            case HandsontableFieldTypeContrants.phone:
              const phoneRegex = new RegExp(Common.PHONE_PATTERN);
              if (!phoneRegex.test(control.value)) {
                return { inValid: true };
              }
              if (control.value.length > 20) {
                return { inValid: true };
              }
              break;
            case HandsontableFieldTypeContrants.email:
              const emailRegex = new RegExp(Common.EMAIL_PATTERN);
              if (!emailRegex.test(control.value)) {
                return { inValid: true };
              }
              break;
            case HandsontableFieldTypeContrants.taxCode:
              // if (!this.validateTaxcode(control.value)) {
              //   return { inValid: true };
              // }
              break;
            case HandsontableFieldTypeContrants.moneyFormat:
              const regex = new RegExp("^[0-9 _ .,]*$");
              if (!regex.test(control.value)) {
                return { inValid: true };
              }
              if (
                control.value[control.value.length - 1] === "." ||
                control.value[control.value.length - 1] === ","
              ) {
                return { inValid: true };
              }
              // let temp = control.value.split(",");
              // if (temp[0].replaceAll(".", "").length > 14) {
              //   return { inValid: true };
              // }
              break;
            case HandsontableFieldTypeContrants.number:
              // case HandsontableFieldTypeContrants.moneyFormat:
              const numberRegex = new RegExp(Common.NUMBER_PATTERN);
              if (!numberRegex.test(control.value)) {
                return { inValid: true };
              }
              break;
            case HandsontableFieldTypeContrants.numberPercent:
              const numberRegexP = new RegExp(Common.NUMBER_PATTERN);
              const value = control.value;
              if (value.substring(value.length - 1, value.length) === "%") {
                const number = value.substring(0, value.length - 1).trim();
                if (!numberRegexP.test(number)) {
                  return { inValid: true };
                }
              } else if (!numberRegexP.test(control.value)) {
                return { inValid: true };
              }
              break;
            default:
              break;
          }
        }
        return null;
      }
      return null;
    };
  }

  fixedMoneyFieldValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const dataType = this.mainFormGroup.get("dataType").value;
        const fixedFunction = this.mainFormGroup.get("fixedFunction").value;
        if (
          !control.value &&
          dataType &&
          dataType === this.DATA_TYPE_FIXED &&
          fixedFunction &&
          fixedFunction === this.NUMBER_TO_MONEY_TEXT
        ) {
          return { required: true };
        }
        return null;
      }
      return null;
    };
  }

  refCategoryValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const dataType = this.mainFormGroup.get("dataType").value;
        if (!control.value && dataType && dataType === this.DATA_TYPE_REF) {
          return { required: true };
        }
        return null;
      }
      return null;
    };
  }

  nameGroupValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.mainFormGroup) {
        const isGroup = this.mainFormGroup.get("isGroup").value;
        const endGroup = control.value ? `END_${control.value.trim()}` : null;
        const findNameGroup = this.dataDialog.listFields.find(
          (item) =>
            item.endGroup === endGroup &&
            ((this.dataDialog.fieldConfig &&
              item.fieldConfigId !==
              this.dataDialog.fieldConfig.fieldConfigId) ||
              !this.dataDialog.fieldConfig)
        );
        if (control.value && endGroup && isGroup && findNameGroup) {
          return { duplicate: true };
        }
        return null;
      }
      return null;
    };
  }

  reFormatLength(data: string) {
    if (data) {
      let temp: string[] = data.split(" ");
      let datatemp = temp.join("");
      let count = 0;
      for (let i = 0; i < datatemp.length; i++) {
        if (datatemp[i] == "0") {
          count += 1;
        } else break;
      }
      return datatemp.slice(count);
    }
  }

  clearData(field: string) {
    this.setValidate(field);
    return this.mainFormGroup.get(field).patchValue(null);
  }

  focusOut(field: string) {
    let value: any = this.mainFormGroup.get(field).value;
    if (value) {
      if (field === "defaultValue") {
        const type = this.mainFormGroup.get("type").value;
        if (type && type === HandsontableFieldTypeContrants.moneyFormat) {
          let value_temp = value.split(".");
          if (value_temp[1] && value_temp[1] != "0") {
            let temp = value.replaceAll(",", "");
            let result_temp = Number(temp).toLocaleString("en-US", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            });
            value = result_temp;
          }
        }
        if (type && type === HandsontableFieldTypeContrants.date) {
          if (value.includes("/") && !value.includes("-")) {
            let temp = value.split("/");
            if (temp[0].length === 1) temp[0] = "0" + temp[0];
            if (temp[1].length === 1) temp[1] = "0" + temp[1];
            value = temp.join("/");
          }

          if (!value.includes("/") && value.includes("-")) {
            let temp = value.split("-");
            if (temp[0].length === 1) temp[0] = "0" + temp[0];
            if (temp[1].length === 1) temp[1] = "0" + temp[1];
            value = temp.join("-");
          }
        }
      } else {
        if (typeof value === "string") {
          value = String(this.mainFormGroup.get(field).value).trim();
        }
      }
    }
    this.mainFormGroup.get(field).patchValue(value);
  }

  setValidate(field: string) {
    if (field === "maxLength") {
      if (
        this.isError("minLength", "pattern") ||
        this.isError("minLength", "checkMinLength")
      ) {
        if (!this.isError("minLength", "pattern")) {
          this.mainFormGroup.controls.minLength.setErrors({
            checkMinLength: true,
          });
        } else if (!this.isError("minLength", "checkMinLength")) {
          this.mainFormGroup.controls.minLength.setErrors({ pattern: true });
        } else {
          this.mainFormGroup.controls.minLength.setErrors({
            pattern: true,
            checkMinLength: true,
          });
        }
      } else {
        this.mainFormGroup.controls.minLength.setErrors(null);
      }
    }
    if (field === "minLength") {
      if (
        this.isError("maxLength", "pattern") ||
        this.isError("maxLength", "checkmaxLength")
      ) {
        if (!this.isError("maxLength", "pattern")) {
          this.mainFormGroup.controls.maxLength.setErrors({
            checkmaxLength: true,
          });
        } else if (!this.isError("maxLength", "checkmaxLength")) {
          this.mainFormGroup.controls.maxLength.setErrors({ pattern: true });
        } else {
          this.mainFormGroup.controls.maxLength.setErrors({
            pattern: true,
            checkmaxLength: true,
          });
        }
      } else {
        this.mainFormGroup.controls.maxLength.setErrors(null);
      }
    }
  }

  searchCategoryField() {
    this.listCategoryField = this.searchCategoryFieldCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => {
        if (!value) {
          return this.listCategoryFields;
        }
        return this.listCategoryFields.filter((st) => {
          const optionLabel = `${st.name}`;
          return optionLabel.toLowerCase().includes(value.trim().toLowerCase());
        });
      })
    );
  }

  getName(field: string) {
    if (this.mainFormGroup.controls.nameGroup.value) {
      if (field === "mergeFieldStart") {
        return "START_" + this.mainFormGroup.controls.nameGroup.value;
      } else {
        return "END_" + this.mainFormGroup.controls.nameGroup.value;
      }
    } else return null;
  }

  handleError(code: string, message: string) {
    switch (code) {
      case ErrorCode.FieldIsDeleted:
        const codes = message.split("###");
        const fieldDeleted = this.listFields.filter((item) => {
          return codes.includes(item.code);
        });
        const fields = fieldDeleted.map((item) => {
          return item.name;
        });
        const messageText = this.dataDialog.fieldConfig
          ? "messages.field_is_deleted_edit_error"
          : "messages.field_is_deleted_create_error";
        this.toastr.error(
          this.commonService.format(
            this.message.getMessage(messageText),
            fields.join(", ")
          )
        );
        break;
      case ErrorCode.CategoryIsDeleted:
      case ErrorCode.RefCategoryIsDeleted:
        this.toastr.error(message);
        if (
          this.mainFormGroup.get("dataType").value === this.DATA_TYPE_SELECT
        ) {
          this.dcFieldConfigService.getCategories().subscribe((res) => {
            this.listDataCategories = []
            if (!res || !res.data) {
              return;
            }
            this.listCategoriesCache = res.data;
            this.mainFormGroup.get("category").patchValue(null);
            this.listCategories = this.listCategoriesCache
              .filter((category) => {
                return (
                  category.code !== "enterprise" &&
                  category.code !== "currency" &&
                  category.code !== "customer"
                );
              })
              .sort((a, b) => {
                return a.name.localeCompare(b.name);
              });
          });
        } else {
          this.mainFormGroup.get("refCategory").patchValue(null);
          const field = this.listFields.find(
            (item) =>
              item.code === this.mainFormGroup.get("relatedFieldCode").value
          );
          if (field && field.category && field.category.categoryId) {
            this.dcFieldConfigService
              .getCategoryByParent(field.category.categoryId)
              .subscribe((res) => {
                if (!res || !res.data) {
                  return;
                }
                this.listCategories = res.data.sort((a, b) => {
                  return a.name.localeCompare(b.name);
                });
              });
          }
        }
        break;
      default:
        if (message) {
          this.toastr.error(message);
        } else {
          this.toastr.error(this.message.getMessage('messages.error_proccessing'));
        }
        break;
    }
  }
  // end validation custom
}
